import React from 'react';
import { useStyletron } from 'baseui';
import { Segment, SegmentedControl } from 'baseui/segmented-control';
import { LabelSmall } from 'baseui/typography';
import { AnnotationsPanel } from './annotations';
import { Tabs } from './const';
import { LabelPanel } from './labels';
import { useSidePanel } from './side-panel-provider';
import type { TabsType } from './types';
const SEGMENTED_CONTROL_HEIGHT = 50;
export const SidePanel = () => {
  const {
    onTabChange,
    activeTab,
    setActiveTab
  } = useSidePanel();
  const [css, theme] = useStyletron();
  return <div className={css({
    padding: theme.sizing.scale800,
    width: '100%',
    boxSizing: 'border-box'
  })}>
      <div className={css({
      width: '100%'
    })}>
        <SegmentedControl activeKey={activeTab} onChange={({
        activeKey
      }) => {
        setActiveTab((activeKey as TabsType));
        onTabChange?.((activeKey as string));
      }} overrides={{
        Root: {
          style: {
            width: '100%',
            height: `${SEGMENTED_CONTROL_HEIGHT}px`
          }
        }
      }}>
          {Object.values(Tabs).map(tab => <Segment key={tab.key} label={<LabelSmall margin={0}>{tab.title}</LabelSmall>} />)}
        </SegmentedControl>
      </div>
      <div className={css({
      width: '100%',
      height: `calc(100% - ${SEGMENTED_CONTROL_HEIGHT}px)`
    })}>
        {activeTab === Tabs.LABELS.key && <LabelPanel />}
        {activeTab === Tabs.ANNOTATIONS.key && <AnnotationsPanel />}
      </div>
    </div>;
};